module.exports = __webpack_public_path__ + "static/media/sent-icon.6985554c.svg";